import { profileKey } from '@staffedupusa/shared-components';
import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import {
  availableSlotsKey,
  errorMessage,
  postWorkHistoryRoute,
  signupBlocksRoute,
  SubmitJobHistoryData,
} from '@features/applicant';
import axiosInstance from '@server/axiosInstance';
import { applicantApplicationsKey } from '@features/applications';

type useSignupInterviewProps = {
  setErrorText: Dispatch<SetStateAction<string>>;
};

export const useSignupInterview = ({
  setErrorText,
}: useSignupInterviewProps) => {
  const client = useQueryClient();

  const {
    mutate: signupInterview,
    isLoading: isSignupInterviewLoading,
  } = useMutation({
    mutationFn: (variables: {
      block_id: number | null;
      app_id: number;
      slot_id?: number;
      is_slot?: boolean;
    }) =>
      axiosInstance
        .post(signupBlocksRoute, variables, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((res) => res.data),
    onSuccess: (data) => {
      if (data.status !== 200) {
        setErrorText(data.message);
      } else {
        setErrorText('');
        // client.invalidateQueries([availableSlotsKey]);
        client.invalidateQueries([applicantApplicationsKey]);
      }
    },
    onError: (error: { message?: string }) => {
      setErrorText(error?.message || errorMessage);
    },
  });

  return {
    signupInterview,
    isSignupInterviewLoading,
  };
};
